import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const ArrowRight: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 8.10256H15M10.2139 12.8889L15.0002 8.10256L10.2139 3.31623"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
